import {makeObservable} from 'mobx';

import type {Nullable} from '../../../utils/utility-types';

import {BaseModel} from '../Base/Base.model';

const ModelName = 'SubtenantExtensionConfigurationModel';

export class SubtenantExtensionConfigurationModel extends BaseModel {
  behavior: SubtenantExtensionConfigurationModel.Behavior;
  custom?: Nullable<
    Record<SubtenantExtensionConfigurationModel.CustomBehavior, boolean>
  > = null;

  constructor(props: SubtenantExtensionConfigurationModel.Props) {
    super(props);
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<
        SubtenantExtensionConfigurationModel,
        SubtenantExtensionConfigurationModel.Props
      >(props),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }

  compare(other: SubtenantExtensionConfigurationModel): boolean {
    const isBehaviorsEqual = this.behavior === other.behavior;

    let isCustomBehaviorsEqual = false;

    if (!this.custom && !other.custom) {
      isCustomBehaviorsEqual = true;
    }

    if (this.custom && other.custom) {
      isCustomBehaviorsEqual = Object.entries(this.custom).every(
        ([key, value]) => other.custom![key] === value,
      );
    }

    return isBehaviorsEqual && isCustomBehaviorsEqual;
  }
}

export namespace SubtenantExtensionConfigurationModel {
  export type Behavior = 'by_external_request' | 'custom' | 'evergreen';

  export type CustomBehavior =
    | 'by_client'
    | 'by_coach'
    | 'by_conference'
    | 'by_subgoal';

  export type Props = BaseModel.ModelToProps<
    SubtenantExtensionConfigurationModel,
    'compare'
  >;
}
